import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { get } from "radash";
import { useEffect, useState } from "react";
import UserService from "src/services/userService";

const ReferralWelcomeCard = ({ partnerId }: { partnerId: string }) => {
  type PartnerData = {
    base64: string;
    partner: {
      _id: string;
      name: string;
      logo: string;
    };
  };

  const [data, setData] = useState<PartnerData>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchPartnerLogo = async () => {
      UserService.getPartnerLogo(partnerId)
        .then((res) => setData(res as PartnerData))
        .catch((error) => {})
        .finally(() => setIsLoading(false));
    };

    // Ignore displaying ognomy.com default referral
    if (partnerId !== "640764110d8a132b03a96a19") fetchPartnerLogo();
  }, [partnerId]);

  const partnerName = get(data, "partner.name");
  if (isLoading || !partnerName) return null;
  return (
    <Card
      elevation={0}
      sx={{
        padding: 1,
        backgroundColor: "background.light",
      }}
    >
      <CardContent>
        <Typography
          variant="h5"
          sx={{
            mb: 0.5,
            lineHeight: 1.5,
            fontWeight: 500,
            fontSize: { xs: "1rem", md: "1.25rem" },
          }}
        >
          Welcome to Ognomy Sleep
        </Typography>
        <Typography
          variant="body1"
          sx={
            {
              // color: "text.light",
              // fontWeight: "normal",
              // fontSize: { xs: "1rem", md: "1.25rem" },
              // lineHeight: 1.5,
            }
          }
        >
          <span style={{ fontWeight: 500 }}>{partnerName || "[referral]"}</span>{" "}
          has referred you to Ognomy Sleep to simplify your sleep apnea care.
        </Typography>
      </CardContent>
    </Card>
  );
};

export default ReferralWelcomeCard;
